// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";

// function ProtectedRoute() {
//   const isLoggedIn = localStorage.getItem("loggedIn");
//   return isLoggedIn === "true" ? <Outlet /> : <Navigate to="login" />;
// }

// export default ProtectedRoute;

import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

function ProtectedRoute({ allowedRoutes }) {
  const isLoggedIn = localStorage.getItem("loggedIn") === "true";
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  // Check if current path starts with any allowed route
  const isAllowed = allowedRoutes.some(
    (route) =>
      location.pathname === route || location.pathname.startsWith(`${route}/`)
  );

  if (!isAllowed) {
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
